require("./myProfileController");
require("./myProfileDirective");
require("./subscriptionHistory/subscriptionHistory");
require("./transactionHistory/transactionHistory");

'use strict';

angular.module('app.myProfile', [
    'app.myProfile.myProfileDirective',
    'app.myProfile.subscriptionHistory',
    'app.myProfile.transactionHistory',
    'app.myProfile.myProfileController'
])
.config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('app.myProfile', {
            url: '/my_profile',
            templateUrl: 'components/myProfile/myProfileView.html'
        });
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/myProfile.js